// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"95218ed0","3411":"95218ed0","4668":"95218ed0","5830":"95218ed0"}[chunkId] + ".chunk.css";
};